import { Button, Link } from 'omakase';
import { FC } from 'react';
import { ReceiptButtonProps } from 'components/business/receipts/ReceiptActionButtons';

const ReceiptCancelTransferButton: FC<ReceiptButtonProps> = ({ variant = 'button', ...rest }) => {
  return variant === 'button' ? (
    <Button variant="basic" size="medium" data-testid="cancel-booking-transfer" fullWidth {...rest}>
      Cancel transfer
    </Button>
  ) : (
    <Link data-testid="cancel-booking-transfer" {...rest}>
      Cancel transfer
    </Link>
  );
};

export default ReceiptCancelTransferButton;
